import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useBranding() {
  const { data, isLoading } = useQuery({
    queryKey: ["platform_settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("platform_settings" as any)
        .select("*")
        .limit(1)
        .single();
      if (error) throw error;
      return data as any;
    },
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    retry: 1,
  });

  return {
    appName: (data?.app_name as string) || "ACEX",
    tagline: (data?.tagline as string) || "Your Trusted Digital Asset Exchange",
    logoUrl: (data?.logo_url as string) || "/acex-logo-dark.png",
    logoLightUrl: (data?.logo_light_url as string) || "/acex-logo-light.png",
    hasLogo: Boolean(data?.logo_url),
    faviconUrl: (data?.favicon_url as string) || "/favicon.svg",
    faviconLightUrl: (data?.favicon_light_url as string) || "/favicon-light.svg",
    ogImageUrl: (data?.og_image_url as string) || "/acex-og.png",
    footerText: (data?.footer_text as string) || "",
    supportEmail: (data?.support_email as string) || "support@acex.market",
    primaryHue: (data?.primary_hue as number) ?? null,
    themePreset: (data?.theme_preset as string) || "neon_blue",
    loading: isLoading,
  };
}
